<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="'重置密码'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="新密码" prop="password" :label-width="formLabelWidth">
					<el-input v-model="addBody.password" type="password" placeholder="请输入新密码"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="repassword" :label-width="formLabelWidth">
					<el-input v-model="addBody.repassword" type="password" placeholder="请再次确认密码"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addArticleCategory,
		UserPassword,
		ArticleCategory
	} from '@/api/user-manage'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					password: '',
					id: '',
					repassword: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
					repassword: [{
						required: true,
						message: '请再次确认密码',
						trigger: 'blur'
					}, ]
				},
				weightList: [],
				weight: '',
				isEdit: false,
			}
		},
		mounted() {},
		methods: {
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().UserPassword()
						} else {
							this.network().addArticleCategory()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addArticleCategory: async () => {
						const {
							status,
							data
						} = await addArticleCategory({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					UserPassword: async () => {
						if (this.addBody.password != this.addBody.repassword) {
							return this.$message.error('两次密码不一致')
						}
						const {
							status
						} = await UserPassword({
							id: this.addBody.id,
							password: this.addBody.password
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					ArticleCategory: async (uuid) => {
						const {
							data,
							status
						} = await ArticleCategory(uuid)
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.addBody.id = val.uuid
					this.isEdit = true;
				} else {
					this.addBody.password = ''
					this.addBody.repassword = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>